"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar2 = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Container_1 = require("../Container/Container");
var Logo_1 = require("../Logo/Logo");
var Media_1 = require("../Media");
var UserMenu_1 = require("../UserMenu/UserMenu");
var SubMenu_1 = require("./SubMenu/SubMenu");
var MainMenu_1 = require("./MainMenu/MainMenu");
var Navbar2_defaults_1 = require("./Navbar2.defaults");
var UserMenu_i18n_1 = require("../UserMenu/UserMenu.i18n");
require("./Navbar2.css");
exports.Navbar2 = react_1.default.memo(function (props) {
    var activePage = props.activePage, className = props.className, isSignedIn = props.isSignedIn, _a = props.i18nNavbar, i18nNavbar = _a === void 0 ? Navbar2_defaults_1.navbarMainTitlesI18N : _a, _b = props.i18nUserMenu, i18nUserMenu = _b === void 0 ? UserMenu_i18n_1.i18n : _b, _c = props.submenuItems, submenuItems = _c === void 0 ? Navbar2_defaults_1.navbarSubmenu : _c, onClickNavbarItem = props.onClickNavbarItem, userMenuProps = __rest(props, ["activePage", "className", "isSignedIn", "i18nNavbar", "i18nUserMenu", "submenuItems", "onClickNavbarItem"]);
    var _d = (0, react_1.useState)(false), toggle = _d[0], setToggle = _d[1];
    var _e = (0, react_1.useState)(), selectedMenu = _e[0], setSelectedMenu = _e[1];
    var _f = (0, react_1.useState)(false), menuMobileOpen = _f[0], setMenuMobileOpen = _f[1];
    var isTabletAndBelow = (0, Media_1.useTabletAndBelowMediaQuery)();
    var handleToggle = (0, react_1.useCallback)(function (e, show, section) {
        setToggle(show);
        show && setSelectedMenu(section);
    }, [setToggle, setSelectedMenu]);
    var handleMobileToggle = (0, react_1.useCallback)(function (e, show) {
        !show && setToggle(false);
        setMenuMobileOpen(show);
    }, [setToggle, setMenuMobileOpen]);
    var handleClickMenu = (0, react_1.useCallback)(function (event, options) {
        onClickNavbarItem && onClickNavbarItem(event, options);
    }, [onClickNavbarItem]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-navbar2', toggle && selectedMenu, menuMobileOpen && 'dui-navbar2__mobile-open', !toggle && 'unselected', className), role: "navigation" },
        react_1.default.createElement(Container_1.Container, { className: "dui-navbar2-container" },
            react_1.default.createElement("div", { className: "dui-navbar2-menu" },
                react_1.default.createElement("div", { className: "dui-navbar2-wrapper" },
                    react_1.default.createElement(Media_1.TabletAndBelow, null,
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-navbar2-toggle', menuMobileOpen && 'open'), onClick: function (e) { return handleMobileToggle(e, !menuMobileOpen); } },
                            react_1.default.createElement("span", { className: "bar" }),
                            react_1.default.createElement("span", { className: "bar" }))),
                    react_1.default.createElement(Media_1.Desktop, null,
                        react_1.default.createElement("a", { className: "dui-navbar2-logo", href: "https://decentraland.org" },
                            react_1.default.createElement(Logo_1.Logo, null)),
                        react_1.default.createElement(MainMenu_1.MainMenu, { activePage: activePage, onToggleShowSubMenu: handleToggle, i18n: i18nNavbar }))),
                react_1.default.createElement(Media_1.TabletAndBelow, null,
                    react_1.default.createElement("a", { className: "dui-navbar2-logo", href: "https://decentraland.org" },
                        react_1.default.createElement(Logo_1.Logo, null))),
                react_1.default.createElement("div", { className: "dui-navbar2-account" },
                    react_1.default.createElement(UserMenu_1.UserMenu, __assign({}, userMenuProps, { isSignedIn: isSignedIn, i18n: i18nUserMenu }))))),
        react_1.default.createElement(SubMenu_1.SubMenu, { selectedMenu: selectedMenu, onToggleShowSubMenu: handleToggle, onClickMenuOption: handleClickMenu, isMobile: isTabletAndBelow, submenus: submenuItems }),
        react_1.default.createElement(Media_1.TabletAndBelow, null,
            react_1.default.createElement(MainMenu_1.MainMenu, { activePage: activePage, onToggleShowSubMenu: handleToggle, isMobile: isTabletAndBelow, i18n: i18nNavbar }))));
});
